<template>
  <div class="articles uk-container">
    <h1>Article</h1>
    <div
      class="uk-grid-large uk-child-width-1-1"
      uk-grid
      uk-scrollspy="target: > div; cls:uk-animation-slide-bottom; delay: 500"
    >

      <div
        v-for="(item, index) in posts"
        :key="item.id"
      >
        <div
          class="uk-card uk-card-hover uk-grid-collapse uk-child-width-1-2@s uk-margin"
          uk-grid
        >
          <div class="uk-flex-last@s uk-card-media-right uk-cover-container">
            <!-- Thumbnail -->
            <img
              v-if="posts[index].better_featured_image === null"
              src="@/assets/images/no-images.jpg"
              alt="NO-Image"
              uk-cover
            >
            <img
              v-else
              :src="posts[index].better_featured_image.media_details.sizes.thumbnail.source_url"
              alt=""
              uk-cover
            >
            <canvas
              width="526"
              height="333"
            ></canvas>
          </div>
          <div>
            <div class="uk-card-body">
              <h3 class="uk-card-title">{{posts[index].title.rendered}}</h3>
              <div v-html="posts[index].excerpt.rendered"></div>
              <div class="date">
                <span class="year">{{moment(posts[index].date).format('YYYY')}}</span>
                <!-- 时间人性化设置 -->
                <span
                  class="day"
                  v-if="moment(posts[index].date).add(8, 'days') > moment()"
                >{{moment(posts[index].date).fromNow()}}</span>
                <span
                  class="day"
                  v-else
                >{{moment(posts[index].date).format('MM.DD')}}</span>
              </div>
            </div>
          </div>
          <router-link
            class="links"
            :to="{path:'/blog/article',query: {id:posts[index].id}}"
          >{{posts[index].title.rendered}}</router-link>
          <!-- <a class="links" href="article">Article Links</a> -->
        </div>
      </div>

    </div>

    <ul class="uk-pagination uk-flex-center uk-margin-xlarge-top uk-margin-xlarge-bottom">
      <li><a
          id="pre"
          @click="pre"
          href="#"
        ><span uk-pagination-previous></span></a></li>
      <li class="active"><a href="#">1</a></li>
      <!-- <li><a href="#">2</a></li>
      <li class="uk-active"><span>3</span></li>
      <li><a href="#">4</a></li>
      <li><a href="#">5</a></li> -->
      <li><a
          id="next"
          @click="next"
          href="#"
        ><span uk-pagination-next></span></a></li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'ArticleLists',
  data () {
    return {
      apiUrl: 'https://api.suuon.net/wp-json/wp/v2/posts',
      posts: {},
      page: 1,
      show: false
    }
  },
  created () {
    this.getPosts(this.page)
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    page: 'getPosts'
  },
  methods: {
    getPosts (p) {
      if (p < 1) {
        p = 1
      }
      // this.$http.get(this.apiUrl + '?_embed=' + p).then(response => {
      this.$http.get(this.apiUrl + '?page=' + p).then(response => {
        // get body data
        response = response.body
        if (response.length > 0) {
          this.posts = response
          document.getElementById('next').style.display = 'block'
        }
        if (response.length < 10) {
          document.getElementById('next').style.display = 'block'
        }
        // alert(response);
        // console.log(this.posts);
        // alert(this.page)
      })
    },
    // 获取class对象
    $class (domclass) {
      var oDiv = document.getElementsByTagName('*')
      var aResult = [] // 定义一个空数组，用来存放与目标className相同的元素
      for (var i = 0; i < oDiv.length; i++) {
        // 这个是遍历页面中所有元素然后拿他们的class进行对比。如果和我们传进来的domclass这个参数一样就把他放进数组 aResult中。
        if (oDiv[i].className === domclass) {
          aResult.push(oDiv[i]) // 获取到的元素推进数组中
        }
        return aResult // 返回这个放进了domclass元素的数组
      }
    },
    getFirstImg (strs) {
      var content = strs
      var str = /<img [^>]*src=['"]([^'"]+)([^>]*>)/gi
      var src = str.exec(content)
      if (src === null || src === undefined || src === []) {
        src = ''
      } else {
        src = src[0]
        src = src.replace(/ height="\d+"/g, '')
        src = src.replace(/ width="\d+"/g, '')
      }
      /* document.getElementById('imgs').src = src
        console.log(src)
      alert(src) */
      return src
    },
    replaceDS (str) {
      /* [&hellip;] */
      var dc = str.replace(/\[&hellip;\]/g, '')
      return dc
    },
    next () {
      scrollTo(0, 0)
      this.page++
      this.showClose()
    },
    pre () {
      scrollTo(0, 0)
      this.page--
    },
    showClose () {
      this.show = !this.show
    }
  }
}
</script>

<style lang="sass">
.articles
  padding-top: 40px
  padding-bottom: 40px
  // box-sizing: border-box
  @media (min-width: 960px)
    max-width: 876px !important
    padding-top: 60px
    padding-bottom: 60px
  @media (min-width: 640px) and (max-width: 959px)
    max-width: 676px !important
  @media (max-width: 639px)
      padding-right: 25px !important
      padding-left: 25px !important
  > h1
    font-size: 4.5rem
    font-weight: bold
    font-family: Roboto, sans-serif
    margin-bottom: 80px
  .uk-card
    // border: 1px solid red
    @media (min-width: 960px)
      display: flex
      justify-content: flex-end
    .uk-cover-container
      @media (min-width: 960px)
        width: 526px
    .uk-card-body
      box-sizing: border-box
      @media (min-width: 960px)
        position: absolute
        left: 0
        top: 50%
        margin-top: -118px
        background-color: white
        padding: 30px 24px
        width: 426px
        height: 237px
        z-index: 1
      @media (min-width: 640px) and (max-width: 959px)
        padding: 8px 0
        max-width: 322px
      @media (max-width: 639px)
        padding: 24px 0
      p
        overflow: hidden
        max-height: 72px
        line-height: 1.5
        @media (min-width: 640px) and (max-width: 959px)
          margin: 16px 0
          max-height: 50px
    .uk-card-title
      max-height: 72px
      overflow: hidden
      font-weight: 300
    > .links
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      width: 100%
      font-size: 0
      z-index: 1
  .date
    >*
      font-weight: normal
    .year
      display: inline-block
      &::after
        @media (max-width: 959px)
          content: '/'
          font-size: 90%
    @media (min-width: 960px) and (max-width: 1140px)
      right: calc(100% + 56px) !important
      transform: rotate(-90deg)
      transform-origin: 100% 0
    @media (min-width: 960px)
      position: absolute
      top: -48px
      right: calc(100% + 24px)
      text-align: right
      color: black
      >*
        display: block
        line-height: 1
      .year
        font-family: Roboto, sans-serif
        font-size: 1rem
      .day
        font-size: 1.5rem
        white-space: nowrap
</style>
